import {
  HIDE_INFORMATION_MODAL,
  SHOW_INFORMATION_MODAL,
} from '@/store/mutation-types';

export default {
  namespaced: true,
  state: {
    isInformationModalVisible: false,
    message: '',
  },
  mutations: {
    [HIDE_INFORMATION_MODAL](state) {
      state.isInformationModalVisible = false;
      state.message = '';
    },
    [SHOW_INFORMATION_MODAL](state, newMessage) {
      state.isInformationModalVisible = true;
      state.message = newMessage;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/information.js